import { PROJECT_STATUS_WORDS, type ProjectStatus } from '@nsb/core';

/**
 * A project's status as a tag (L-25b, Jason, 2026-10-08: a completed job's tag reads Completed, never CLOSED, "same with
 * canceled (red) and paused with the pause icon"): its word, the one Settings and the Projects page use
 * (`PROJECT_STATUS_WORDS`), never the database's, with its colour and mark. Completed in moss, Cancelled in bengara,
 * Paused with a pause mark, Archived plain; a project under way (active) carries none. One rule wherever a status is a
 * tag (`ProjectStatus.tsx` draws it): the Projects page's rows and a project's own header. The word is always there, so
 * colour is never the only signal (guide §20.8).
 */
export const STATUS_TAGS: Record<Exclude<ProjectStatus, 'active'>, { tone: 'plain' | 'moss' | 'alert'; mark: 'pause' | null }> = {
  paused: { tone: 'plain', mark: 'pause' },
  closed: { tone: 'moss', mark: null },
  cancelled: { tone: 'alert', mark: null },
  archived: { tone: 'plain', mark: null },
};

/** The tag a status has: its words, colour and mark; null for a project under way, which carries none. */
export function statusTag(status: ProjectStatus): { words: string; tone: 'plain' | 'moss' | 'alert'; mark: 'pause' | null } | null {
  if (status === 'active') return null;
  return { words: PROJECT_STATUS_WORDS[status], ...STATUS_TAGS[status] };
}
